import type { AppStrings } from './types.js';

export const tr: AppStrings = {
  // COMMON
  error_title: 'Hata',
  cancel: 'İptal',
  retry: 'Tekrar dene',
  back_arrow: '← Geri',

  // ASK SCREEN
  ask_box_unavailable: 'Kutu mevcut değil',
  ask_box_unavailable_desc: 'Bağlantı eskimiş olabilir ya da sahibi kutuyu kapattı.',
  ask_create_own_box: 'Kendi kutunu oluştur',
  ask_sent_title: 'Gönderildi ✅',
  ask_sent_desc: 'Anonim sorun kutu sahibine iletildi.',
  ask_anonymous_hint: 'Sorun anonim olarak gönderilecek.',
  ask_placeholder: 'Soruyu yaz…',
  ask_send: 'Gönder',
  ask_sending: 'Gönderiliyor…',
  ask_error_rate_limit: 'Çok fazla istek — bir dakika bekle.',
  ask_error_restart: 'Lütfen Mini App\'i yeniden başlat.',
  ask_error_load: 'Kutu yüklenemedi.',
  ask_error_send: 'Soru gönderilemedi.',
  ask_error_banned: 'Uygulamada engellendiniz.',
  ask_banned_appeal_btn: 'İtiraz et',
  ask_appeal_sent: 'İtiraz gönderildi. Manuel olarak inceleyeceğiz.',

  // AGE GATE
  age_gate_title: 'Yalnızca 18+',
  age_gate_desc:
    'Anonim bir soru gönderiyorsun. Saygılı ol: taciz, tehdit, küçüklere yönelik cinsel içerik ve yasaları ihlal eden her türlü içerik yasaktır. Anonimlik cezasızlık anlamına gelmez — ihlaller moderasyona bildirilir. Soru göndererek 18+ olduğunu onaylıyor ve kuralları kabul ediyorsun.',
  age_gate_confirm: '18 yaşındayım — devam et',

  // INBOX SCREEN
  inbox_title: 'Kutun',
  box_link_accordion: 'Davet bağlantısı',
  inbox_notifications_ask: '🔔 Bot yeni sorular için bildirim gönderebilir mi?',
  inbox_notifications_allow: 'İzin ver',
  inbox_notifications_dismiss_label: 'Kapat',
  inbox_box_toggle_disable: 'Soruları kapat',
  inbox_box_toggle_enable: 'Soruları aç',
  inbox_box_disabled_warning: 'Sorular kapalı — yeni sorular kabul edilmeyecek.',
  inbox_share_hint: 'Bağlantıyı paylaş, arkadaşların sana anonim sorular sorabilsin.',
  inbox_copy: 'Kopyala',
  inbox_copied: 'Kopyalandı',
  inbox_copy_error: 'Hata',
  inbox_no_deeplink: 'Bağlantı deploy sonrasında görünecek.',
  inbox_invite_story: 'Story ile davet et',
  inbox_invite_chat: 'Sohbet ile davet et',
  inbox_card_rendering: 'Davet kartı hâlâ hazırlanıyor.',
  inbox_story_unsupported:
    'Story\'ler bu Telegram sürümünde mevcut değil. "Sohbet ile" seçeneğini dene.',
  inbox_story_error: 'Story açılamadı.',
  inbox_chat_unsupported:
    'Sohbet paylaşımı bu Telegram sürümünde mevcut değil. İstemcini güncelle.',
  inbox_chat_error: 'Paylaşım başarısız. Tekrar dene.',
  inbox_chat_prepare_error: 'Davet hazırlanamadı.',
  inbox_filter_incoming: 'Gelen',
  inbox_filter_hidden: 'Gizli',
  inbox_filter_blocked: 'Engelli',
  inbox_filter_empty: 'Burada henüz bir şey yok.',
  inbox_acc_unanswered: 'Yanıtsız',
  inbox_acc_answered: 'Yanıtlandı',
  inbox_acc_hidden: 'Gizli',
  inbox_acc_blocked: 'Engelli',
  inbox_empty: 'Henüz soru yok. Yukarıdaki bağlantıyı paylaş.',
  inbox_load_more: 'Daha fazla yükle',
  inbox_load_more_error: 'Sonraki sayfa yüklenemedi.',
  inbox_error_load: 'Kutu yüklenemedi.',
  inbox_rate_limit: 'Çok fazla istek — bir dakika bekle.',
  inbox_toggle_error: 'Kutu durumu değiştirilemedi.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Bana anonim olarak yaz',
  message_placeholder: 'Mesaj yaz…',
  message_anonymous_hint: 'Mesajın anonim olarak gönderilecek.',
  message_sent_title: 'Gönderildi ✅',
  message_sent_desc: 'Anonim mesajın iletildi.',
  message_owner_entry: 'Bana yaz',
  message_share_hint: 'Bağlantıyı paylaş, herkes sana anonim mesaj gönderebilsin.',
  message_inbox_open: 'Gelen mesajlar',
  message_inbox_title: 'Mesajlar',
  message_inbox_empty: 'Henüz mesaj yok. Yukarıdaki bağlantını paylaş.',

  // ANSWER SCREEN
  answer_title: 'Soruyu yanıtla',
  answer_placeholder: 'Yanıtı yaz…',
  answer_submit: 'Gönder',
  answer_submitting: 'Gönderiliyor…',
  answer_back: 'Geri',
  answer_error_send: 'Yanıt gönderilemedi.',

  // SHARE SCREEN
  share_title: 'Yanıt yayınlandı ✅',
  share_hint: 'Kartı paylaş ve daha fazla soru topla.',
  share_card_rendering_desc:
    'Kart hâlâ hazırlanıyor. Sorulara geri dön ve biraz sonra tekrar bak — Story veya sohbette paylaşabileceksin.',
  share_card_alt: 'Yanıt kartı',
  share_story_btn: 'Story\'de paylaş',
  share_story_btn_busy: 'Açılıyor…',
  share_chat_btn: 'Sohbette paylaş',
  share_chat_btn_busy: 'Hazırlanıyor…',
  share_back: 'Sorulara dön',
  share_story_unsupported:
    'Story\'ler bu Telegram sürümünde mevcut değil. "Sohbette paylaş" seçeneğini dene.',
  share_story_error: 'Story açılamadı. "Sohbette paylaş" seçeneğini dene.',
  share_chat_sent: 'Mesaj gönderildi.',
  share_chat_unsupported:
    'Sohbet paylaşımı bu Telegram sürümünde mevcut değil. İstemcini güncelle.',
  share_chat_error: 'Paylaşım başarısız. Tekrar dene.',
  share_chat_prepare_error: 'Mesaj hazırlanamadı.',

  // LEADERBOARD SCREEN
  lb_title: 'Lider tablosu',
  lb_period_7d: '7 gün',
  lb_period_30d: '30 gün',
  lb_period_all: 'Tüm zamanlar',
  lb_group_label: 'Kategori',
  lb_group_all: 'Hepsi',
  lb_group_ask: 'Sorular',
  lb_group_rate: 'Değerlendirme',
  lb_group_confession: 'İtiraf',
  lb_group_guesswho: 'Kim bu?',
  lb_group_message: 'Mesajlar',
  lb_error: 'Lider tablosu yüklenemedi',
  lb_empty: 'Sıralamada henüz kimse yok',
  lb_anon: 'Anonim',
  lb_load_more: 'Daha fazla yükle',
  lb_questions: (n) => `${n} soru`,
  lb_referrals: (n) => `${n} ref.`,

  // REWARDS SCREEN
  rw_title: 'Ödüllerim',
  rw_error: 'Ödüller yüklenemedi',
  rw_level: (n) => `Seviye ${n}`,
  rw_confirmed_referrals: (n) => `${n} onaylı referans`,
  rw_next_level_section: (n) => `SONRAKİ SEVİYE — ${n} referans`,
  rw_to_level: (level, target) => `seviye ${level} için: ${target}`,
  rw_max_level: 'Maksimum seviyeye ulaşıldı!',
  rw_badges_section: 'ROZETLER',
  rw_formats_section: 'KUTU FORMATLARI',

  // QUESTION CARD
  qcard_status_new: 'Yeni',
  qcard_status_hidden: 'Gizli',
  qcard_status_answered: 'Yanıtlandı',
  qcard_moderation_flagged: 'Dikkat: şüpheli mesaj',
  qcard_answer_btn: 'Yanıtla',
  qcard_answer_send: 'Gönder',
  qcard_share_btn: 'Paylaş',
  qcard_hide_btn: 'Gizle',
  qcard_show_btn: 'Göster',
  qcard_report_btn: 'Şikâyet et',
  qcard_block_btn: 'Engelle',
  qcard_unblock_btn: 'Engeli kaldır',
  qcard_report_reason_label: 'Şikâyet nedenini seç:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Taciz',
  qcard_reason_sexual: 'Cinsel içerik',
  qcard_reason_other: 'Diğer',
  qcard_error_hide: 'Görünürlük değiştirilemedi.',
  qcard_error_report: 'Şikâyet gönderilemedi.',
  qcard_error_block: 'Gönderici engellenemedi.',
  qcard_report_done: 'Şikâyet gönderildi — teşekkürler.',
  qcard_block_done: 'Gönderici engellendi.',
  qcard_unblock_done: 'Gönderici engeli kaldırıldı.',

  // ERRORS (common humanized error messages)
  err_network: 'Sunucuya bağlanılamıyor. İnternetini kontrol et ve tekrar dene.',
  err_server_unavailable: 'Sunucu geçici olarak kullanılamıyor, lütfen daha sonra tekrar dene.',
  err_internal: 'Bizim tarafımızda bir şeyler ters gitti. Zaten bakıyoruz — daha sonra tekrar dene.',
  err_bad_request: 'Girilen verileri kontrol et.',
  err_generic: 'İşlem tamamlanamadı, lütfen daha sonra tekrar dene.',
  err_schema: 'Veri hatası. Uygulamayı güncellemeyi dene.',
  share_story_link_premium_note:
    'Story\'lerde tıklanabilir bağlantı Telegram Premium gerektirir. Onsuz da arkadaşların seni bulabilir — kullanıcı adın kartta görünüyor.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Erişim hatası',
  auth_error_desc:
    'Kimlik doğrulama başarısız. Lütfen Mini App\'i kapat ve Telegram\'dan yeniden aç.',

  // REWARD TOAST
  reward_toast_title: 'Yeni ödül!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Sorular',
  tab_leaderboard: 'Lider tablosu',
  tab_rewards: 'Ödüller',
  tab_settings: 'Ayarlar',

  // SETTINGS SCREEN
  settings_title: 'Ayarlar',
  settings_section_general: 'Genel',
  settings_notifications: 'Yeni soru bildirimleri',
  settings_notifications_hint: 'Bot, biri soru sorduğunda sana mesaj gönderir.',
  settings_notifications_error: 'Bildirim ayarı kaydedilemedi.',
  settings_language: 'Dil',
  settings_language_error: 'Dil değiştirilemedi. Tekrar dene.',
  settings_section_about: 'Uygulama hakkında',
  settings_version: 'Sürüm',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story bağlantıları yalnızca Premium için',
  code_modal_explain:
    'Telegram yalnızca Premium abonelere tıklanabilir story bağlantısı veriyor. Bunun yerine story\'ye kodunu ekle — izleyiciler onu uygulamaya girer ve sana anonim bir soru sorar.',
  code_modal_your_code: 'Senin kodun',
  code_modal_copy: 'Kodu kopyala',
  code_modal_copied: 'Kopyalandı',
  code_modal_share_btn: 'Story\'de paylaş',
  code_modal_loading: 'Kod alınıyor…',
  code_modal_error: 'Kodun alınamadı. Daha sonra tekrar dene.',
  ask_code_title: 'Kod gir',
  ask_code_desc:
    'Bir story\'den mi geldin? Kodunu orada bul (örn. 1234) ve aşağıya yaz.',
  ask_code_placeholder: 'Story\'deki kod',
  ask_code_find: 'Bul',
  ask_code_not_found: 'Kod bulunamadı. Rakamları kontrol edip tekrar dene.',
  ask_code_invalid: 'Kod 4 rakamdan oluşur.',
  code_onboarding_header: 'Bir story\'den mi geldin?',
  code_onboarding_text: 'Bir arkadaşının kodunu girerek ona anonim soru sor.',
  code_onboarding_action: 'Kod gir',
  settings_ask_by_code: 'Kodla sor',
  settings_my_code_title: 'Story kodun',
  settings_my_code_hint:
    'Bu kodu story\'ne yaz — izleyiciler sana anonim soru sormak için girer. Telegram yalnızca Premium abonelere tıklanabilir story bağlantısı veriyor.',
  settings_my_code_rotate: 'Yeni kod al',
  settings_my_code_rotating: 'Güncelleniyor…',
  settings_my_code_done: 'Kod güncellendi',
  settings_my_code_error: 'Kodun alınamadı.',
  settings_my_code_rotate_confirm_title: 'Kodu değiştir?',
  settings_my_code_rotate_confirm_desc:
    'Eski kodun anında çalışmayı bırakır. Story\'nde kodu görenler artık sana ulaşamaz. Bunu sadece biri spam yapıyorsa yap.',
  settings_my_code_rotate_confirm_action: 'Kodu değiştir',

  // BOT
  bot_greeting: (name) => (name ? `Merhaba, ${name}! 👋` : 'Merhaba! 👋'),
  bot_onboarding:
    'Bu VeylMe — anonim sorular.\n\n' +
    'Mini App\'i aç, Story\'ne «Bana anonim sor» kartı yayınla — ' +
    've anonim soruları doğrudan buradan al.\n\n' +
    '⚠️ 18+. Saygılı ol: zorbalık, tehdit ve yasaklı içerik ' +
    'yasaktır. Anonimlik ≠ cezasızlık — ihlaller moderasyona iletilir.',
  bot_open_btn: 'VeylMe\'yi aç',
  notify_answer_btn: 'Yanıtla',
  bot_invite_text:
    'Birisi VeylMe bağlantısını paylaştı.\n\n' +
    'Anonim soru sormak için Mini App\'i aç:',
  bot_invite_btn: 'Anonim sor',

  // WORK-027 i18n sweep
  tagline: 'Bana anonim olarak sor',
  share_ask_action: 'Sor',
  share_answered_text: 'Anonim bir soruyu yanıtladım 👀',
  err_not_in_telegram: 'Mini App Telegram içinde çalışmıyor. Lütfen uygulamayı yeniden başlat.',
  badge_viral_starter: 'Viral başlangıç',
  badge_storyteller: 'Hikaye anlatıcısı',
  badge_loop_master: 'Döngü ustası',
  theme_confession: 'İtiraflar',
  theme_guesswho: 'Kim bu?',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Soru',
  card_label_answer: 'Yanıt',
  card_invite_subtitle: 'anonim, kayıt gerektirmez',
  card_code_hint: 'KODU UYGULAMAYA GİR',
  share_msg_title: (brand) => `${brand} · Anonim sorular`,
  notify_new_question: '🔔 Biri sana anonim bir soru sordu',
  notify_unanswered_reminder: (n) => `🔔 ${n} yanıtsız sorun var`,
  notify_ban_permanent: 'kalıcı olarak',
  notify_ban_until: (date) => `${date} tarihine kadar`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ VeylMe'de ${untilPhrase} engellendin. Çok fazla alıcı mesajlarını şikâyet etti.\nBunun bir hata olduğunu düşünüyorsan, uygulamada itiraz gönderebilirsin.`,
  notify_warning_msg:
    '⚠️ Birkaç alıcı mesajlarını şikâyet etti. Biraz daha ve VeylMe\'de engellenirsin.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Sorularım',
  my_questions_empty_title: 'Henüz bir soru sormadın',
  my_questions_empty_desc: 'Birinin kutusuna bir soru sor — yanıt burada görünecek.',
  my_questions_loading: 'Yanıt kontrol ediliyor…',
  my_questions_waiting: 'Yanıt bekleniyor',
  my_questions_answer_label: 'Yanıt',
  settings_my_questions: 'Sorularım',
  ask_sent_find_reply_hint: 'Yanıtı daha sonra «Sorularım» bölümünde bulabilirsin.',
  inbox_story_nonpremium_hint: 'Telegram Premium olmadan Story bağlantısı tıklanabilir değildir, bu yüzden bir kod gösteriyoruz — sohbette paylaşmak daha güvenilirdir.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram izninin süresi doldu',
  session_expired_desc: 'Telegram uygulamaya izni yalnızca açılışta bir kez verir ve bunun süresi doldu. Uygulamayı yeniden aç — başladığın metni kaydettik.',
  session_expired_desc_no_storage: 'Telegram erişim izninin süresi doldu, uygulamanın yeniden açılması gerekiyor. Yazdığın metni kaydedemedik — çıkmadan önce kopyala.',
  session_expired_reopen: 'Yeniden aç',
  session_expired_stuck_title: 'Telegram aynı eski izni verdi',
  session_expired_stuck_desc: 'Uygulamayı bot menüsünden tamamen kapat ve yeniden aç — o zaman Telegram yeni bir izin verir.',
  session_auth_failed_title: 'Girişin doğrulanamadı',
  session_auth_failed_desc: 'Telegram uygulamaya girişini doğrulamadı. Uygulamayı kapat ve botla olan sohbetten yeniden aç.',
  session_expired_manual_close: 'Uygulama burada kendini kapatamaz — onu kendin kapat ve botla olan sohbetten yeniden aç.',
  session_expiring_soon: 'Telegram izninin süresi yakında dolacak. Hiçbir şey kaybolmasın diye uygulamayı yeniden aç.',
  my_questions_check_failed: 'Yanıtlar kontrol edilemedi. Daha sonra dene.',
  settings_notifications_load_error: 'Ayar yüklenemedi.',
};
